import * as _ from 'lodash';
import { getLogger } from '../diagnostics/logger';
import moment from 'moment';
import { Action, ActionMeta } from '../actions';
import {
  CLEAR_AVAILABLE_TELS,
  LOAD_AVAILABLE_TELS_FAILURE,
  LOAD_AVAILABLE_TELS_PENDING,
  LOAD_AVAILABLE_TELS_SUCCESS,
  SIM_PROVISION_TEL_CHANGED,
} from '../actions/actionTypes';
import {
  LoadAvailableTelsFailurePayload,
  LoadAvailableTelsSuccessPayload,
  LoadTelsFilter,
} from '../models/AvailableTels';
import { simSwapValueUpdate } from '../models/payload/simSwapValueUpdate';
import { initialAppState } from '../models/state/appState';
import {
  AvailableTelsCacheTimeout,
  AvailableTelsState,
  getDefaultAvailableTelsState,
} from '../models/state/availableTelsState';

const log = getLogger('simManagement.reducers.availableTelsReducer');

export default function spendCapReducer(
  state: AvailableTelsState = initialAppState.availableTels,
  action: Action<any>,
): AvailableTelsState {
  switch (action.type) {
    case CLEAR_AVAILABLE_TELS:
      return getDefaultAvailableTelsState();
    case LOAD_AVAILABLE_TELS_PENDING: {
      const payload = action.payload as LoadTelsFilter;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const changedState: Partial<AvailableTelsState> = {
        isLoading: true,
        filter: payload,
      };

      const newState = Object.assign({}, getDefaultAvailableTelsState(), changedState);
      return newState;
    }
    case LOAD_AVAILABLE_TELS_FAILURE: {
      const payload = action.payload as LoadAvailableTelsFailurePayload;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const changedState: Partial<AvailableTelsState> = {
        error: payload.error,
        filter: payload.filter,
      };

      const newState = Object.assign({}, getDefaultAvailableTelsState(), changedState);
      return newState;
    }
    case LOAD_AVAILABLE_TELS_SUCCESS: {
      const payload = action.payload as LoadAvailableTelsSuccessPayload;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const all = payload.tels.map((t) => ({
        label: t,
      }));

      const byTel = Object.assign({}, ...payload.tels.map((t) => ({ [t]: true })));

      // removed the SIM_PROVISION_TEL_CHANGED section as it wasn't able to deal with duplicates
      // changed the underlying mechanism for keeping tabs on which values have already been used
      // therefore byTel values will now always be set to true.
      // TODO: simplify structure, as we no longer need something so complex.
      return {
        filter: payload.filter,
        all,
        available: _.filter(all, (t) => byTel[t.label] === true),
        byTel,
        isLoading: false,
        expiresOn: moment().add(AvailableTelsCacheTimeout, 'seconds').toDate(),
        lastLoadedOn: new Date(),
      };
    }
    default:
      return state;
  }
}
